import React from "react";

const configuredMainUrl = String(
  process.env.REACT_APP_MAIN_URL || process.env.REACT_APP_CUSTOMER_PORTAL_URL || ""
).trim();

const normalizedMainUrl = (() => {
  if (!configuredMainUrl) return "";
  if (
    /^https?:\/\//i.test(configuredMainUrl) ||
    configuredMainUrl.startsWith("/") ||
    configuredMainUrl.startsWith("#")
  ) {
    return configuredMainUrl;
  }

  if (/^[\w.-]+\.[a-z]{2,}(\/.*)?$/i.test(configuredMainUrl)) {
    return `https://${configuredMainUrl}`;
  }

  return "";
})();

const Header = ({
  company = "Daily Work Log",
  user = "User",
  roleLabel = "",
  onLogout,
  theme = "dark",
  onToggleTheme,
  nextThemeLabel = "Light Mode"
}) => {
  const handleHeaderLeftClick = () => {
    if (typeof window === "undefined") return;
    window.location.href = normalizedMainUrl || "/";
  };

  return (
  <header className="page-header">
    <div className="header-container">
      <div
        className="header-left"
        role="button"
        tabIndex={0}
        style={{ cursor: "pointer" }}
        onClick={handleHeaderLeftClick}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleHeaderLeftClick();
          }
        }}
        aria-label="Go to main app"
      >
        <img className="header-logo" src={`${process.env.PUBLIC_URL}/favicon.ico`} alt={`${company} logo`} />
        <h2 className="company-name">{company}</h2>
      </div>
      <div className="header-right">
        <button className="theme-toggle-btn" onClick={onToggleTheme}>
          {nextThemeLabel || (theme === "dark" ? "Light Mode" : "Dark Mode")}
        </button>
        <div className="user-info">
          <span className="user-label">Logged in as:</span>
          <span className="user-name">{roleLabel ? `${user} (${roleLabel})` : user}</span>
        </div>
        <button className="logout-btn" onClick={onLogout}>Logout</button>
      </div>
    </div>
  </header>
  );
};

export default Header;
